import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchAllDiscounts,
  createDiscount,
  updateDiscount,
  deleteDiscount,
} from "services/discount";

export const useAllDiscounts = (filters = {}, options = {}) => {
  const { enabled = true, refetchOnWindowFocus = true } = options;
  const query = useQuery({
    queryKey: ["all-discounts", filters],
    queryFn: () => fetchAllDiscounts(filters),
    enabled,
    refetchOnWindowFocus,
  });
  return query;
};

export const useCreateDiscount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createDiscount,
    onSuccess: (data) => {
      // Invalidate all discount queries (both general and filtered)
      queryClient.invalidateQueries({ queryKey: ["all-discounts"] });
    },
  });
};

export const useUpdateDiscount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateDiscount(id, data),
    onSuccess: (data, variables) => {
      // Invalidate all discount queries (both general and filtered)
      queryClient.invalidateQueries({ queryKey: ["all-discounts"] });
      // Invalidate specific discount record
      queryClient.invalidateQueries({ queryKey: ["one-discount", variables.id] });
    },
  });
};

export const useDeleteDiscount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteDiscount,
    onSuccess: (data, id) => {
      // Invalidate all discount queries (both general and filtered)
      queryClient.invalidateQueries({ queryKey: ["all-discounts"] });
      // Invalidate specific discount record
      queryClient.invalidateQueries({ queryKey: ["one-discount", id] });
    },
  });
};
